import React from 'react';
import PropTypes from 'prop-types';

export default function DownloadIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 12 16" {...rest}>
      <path
        fill={color}
        d="M5.26,-2.7533531e-14 L6.76,-2.7533531e-14 L6.76,10.18 L9.36,7.58 L10.42,8.64 L6,13.06 L1.58,8.64 L2.64,7.58 L5.26,10.18 L5.26,-2.7533531e-14 Z M0,14.5 L12,14.5 L12,16 L0,16 L0,14.5 Z"
      />
    </svg>
  );
}

DownloadIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

DownloadIcon.defaultProps = {
  size: 15,
  color: '#000',
};
